module.exports = __webpack_public_path__ + "static/logo-text-c9fee9a4a45b58f854051bd05c81c395.svg";